import React from 'react'
import type { OptionProps } from 'react-select'
import { components } from 'react-select'

import Checkbox from '../../../Checkbox/Checkbox'
import type { MyOptionType } from '../../Select.types'

const Option = (props: OptionProps) => {
  const { innerProps, isMulti, isSelected, children, data, isDisabled } = props

  return (
    <components.Option
      {...props}
      innerProps={
        {
          ...innerProps,
          'data-e2e': 'select-menu-option',
          tabIndex: isDisabled ? -1 : innerProps.tabIndex,
        } as any
      }
    >
      {isMulti ? (
        /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
        <div onClick={e => e.preventDefault()}>
          <Checkbox
            checked={isSelected}
            content={children}
            disabled={isDisabled}
            name={(data as MyOptionType<string | number>).value.toString()}
          />
        </div>
      ) : (
        children
      )}
    </components.Option>
  )
}

export default Option
